import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const PropertySidebar = ({ 
  properties, 
  selectedProperty, 
  onSelectProperty, 
  searchTerm, 
  onSearchChange,
  onAddNew 
}) => {
  const filteredProperties = properties?.filter(property =>
    property?.title?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
    property?.propertyId?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  );

  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400';
      case 'pending':
        return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400';
      case 'draft':
        return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'active':
        return 'نشط';
      case 'pending':
        return 'قيد المراجعة';
      case 'draft':
        return 'مسودة';
      default:
        return status;
    }
  };

  return (
    <div className="w-full lg:w-64 bg-card border-l border-border h-full flex flex-col">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-base font-heading font-semibold text-foreground">
            قائمة العقارات
          </h2>
          <button
            onClick={onAddNew}
            className="p-2 rounded-lg bg-primary text-primary-foreground hover:opacity-90 transition-all duration-250"
            aria-label="إضافة عقار جديد"
          >
            <Icon name="Plus" size={18} />
          </button>
        </div>

        <Input
          type="search"
          placeholder="البحث عن عقار..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="w-full"
        />
      </div>
      <div className="flex-1 overflow-y-auto overflow-x-hidden p-3">
        <div className="space-y-2">
          {filteredProperties?.length === 0 ? (
            <div className="text-center py-8 text-muted-foreground">
              <Icon name="Search" size={48} className="mx-auto mb-2 opacity-50" />
              <p className="text-sm">لا توجد نتائج</p>
            </div>
          ) : (
            filteredProperties?.map((property) => (
              <button
                key={property?.id}
                onClick={() => onSelectProperty(property)}
                className={`w-full text-right p-3 md:p-4 rounded-lg border transition-all duration-250 ${
                  selectedProperty?.id === property?.id
                    ? 'bg-primary/10 border-primary shadow-warm'
                    : 'bg-card border-border hover:bg-muted hover:shadow-warm-sm'
                }`}
              >
                <div className="flex items-start justify-between gap-2 mb-2">
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm md:text-base font-medium text-foreground truncate">
                      {property?.title}
                    </h3>
                    <p className="text-xs text-muted-foreground font-data mt-1">
                      {property?.propertyId}
                    </p>
                  </div>
                  <span className={`text-xs px-2 py-1 rounded-full whitespace-nowrap ${getStatusColor(property?.status)}`}>
                    {getStatusLabel(property?.status)}
                  </span>
                </div>

                <div className="flex items-center gap-4 text-xs text-muted-foreground">
                  <div className="flex items-center gap-1">
                    <Icon name="MapPin" size={14} />
                    <span className="truncate">{property?.city}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="Banknote" size={14} />
                    <span className="whitespace-nowrap font-data">{property?.price}</span>
                  </div>
                </div>
              </button>
            ))
          )}
        </div>
      </div>
      <div className="p-4 border-t border-border bg-muted/50">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">إجمالي العقارات</span>
          <span className="font-medium text-foreground font-data">{properties?.length}</span>
        </div>
      </div>
    </div>
  );
};

export default PropertySidebar;